import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "head" }
const _hoisted_2 = { class: "output-content" }
const _hoisted_3 = {
  key: 1,
  class: "raw"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Tabs = _resolveComponent("Tabs")
  const _component_MdContent = _resolveComponent("MdContent")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    "dialog-class": "output-modal",
    max_width: $options.chat_width,
    onClickOutside: $options.close
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createTextVNode(" Output ")),
        _createVNode(_component_Icon, {
          class: "pointer",
          disabled: _ctx.loading,
          icon: "x-close",
          stroke: "var(--gray-400)",
          height: "2rem",
          width: "2rem",
          onClick: $options.close
        }, null, 8 /* PROPS */, ["disabled", "onClick"])
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Tabs, {
          modelValue: $data.active,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.active) = $event)),
          class: "tabs",
          tabs: $data.tabs,
          bordered: ""
        }, null, 8 /* PROPS */, ["modelValue", "tabs"]),
        _createVNode(_component_ScrollBar, { class: "scroller" }, {
          default: _withCtx(() => [
            ($data.active === 'markdown')
              ? (_openBlock(), _createBlock(_component_MdContent, {
                  key: 0,
                  class: "md",
                  markdown: $data.md
                }, null, 8 /* PROPS */, ["markdown"]))
              : ($data.active === 'raw')
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$utils.str.escapeRawString($data.md)), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["max_width", "onClickOutside"]))
}